import {NotifyItem} from 'libs/notification/notificationProvider';

export const unknownValidation: NotifyItem = {
    id: 'unknown-validation',
    title: 'Validierung fehlgeschlagen!',
    message: 'Eine Validierung ist fehlgeschlagen.',
    type: 'default'
}
